/* eslint-disable comma-dangle */
/* eslint-disable no-nested-ternary */
import React, { useEffect, useState } from "react";
import {
  CircularProgress,
  Alert, 
  AlertTitle,
  Button,
  Chip,
  TextField,
  Select,
  MenuItem,
  Paper,
  Typography,
  Tooltip,
  Checkbox,
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Modal,
  Tab,
  Tabs,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  DialogContentText,
   Grid
} from "@mui/material";
import {
  Lock,
  ExpandMore,
  Help,
} from '@mui/icons-material';
import { Theme, useTheme } from '@mui/material/styles'
import { createStyles, makeStyles } from '@mui/styles';
import { useLocalStorage } from "../../utils/LocalStorageHook";
import TableAbstraction from "../../componentUtils/TableAbstraction";
import {checkForRole} from "../../utils/GetAuth";
import {formatDate, formatDateTime, getUniqueStringList} from "../../utils/Formatter";
import {  GetActiveMaterialData,deleteVSImageFromBlob} from "../../utils/GetAdmin";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    centerDiv: {
      margin: '0',
      position: 'absolute',
      top: '50%',
      left: '50%'
    },
    root: {
      margin: '0',
      padding:'0'

    },
    divWidth: {
      width: "100%"
    },
    gridSpaceable: {
      padding: theme.spacing(2)
    },
    gridMarginTop: {
      marginTop: theme.spacing(2)
    },
    paragraph: {
      padding: theme.spacing(1)
    },
    paragraphAct: {
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2)
    },
    paper: {
        position: 'absolute',
        backgroundColor: theme.palette.background.paper,
        border: '1px solid #000',
        boxShadow: theme.shadows[4],
        padding: theme.spacing(2, 2, 2)
    },
    checkbox: {
      padding: 0,
      "&$disabled": {
        color: theme.palette.primary.main
      }
    },
    navtab: {
      backgroundColor: theme.palette.grey[100],
    },
    navtabsel: {
      backgroundColor: theme.palette.grey[400],
    },
    primary: {
      marginTop: theme.spacing(2)
    },
    button: {
      marginLeft: theme.spacing(2),
      minWidth: 150
    },
    
    modal: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    modalGrid: {
      marginTop: theme.spacing(2),
    },
    modalTitle:{
      color: theme.palette.primary.main,
    },
    modalCard: {
    },
    modalText: {
      width: 800,
    },
    modalInput: {
      paddingLeft: "2px", 
      paddingRight: "20px", 
      width:"300px"
    },
    
    ImagDisp: {
      position: "relative",
      margin: "0px auto",
      pointerEvents: "all",
      zIndex: "9",
    },
imageDispTable:{
  border: "1px solid rgb(222, 226, 230);",
  borderCollapse: "collapse"
},
  }));

  function getModalStyle() {
    const top = 50;
    const left = 50;
  
    return {
        top: `${top}%`,
        left: `${left}%`,
        transform: `translate(-${top}%, -${left}%)`,
    };
  }

function LoadingSpinner(){
  return (<CircularProgress />)
}


export default function CompareMaterialImage() {
  const classes = useStyles();
  const [salesOrg] = useLocalStorage("SETTINGS.salesOrg", "");
  const [doneLoading, setDoneLoading] = React.useState<boolean>();
  const [clientId] = useLocalStorage("SETTINGS.clientId", "100");
  const [compareMaterData, SetompareMaterData] = useState<any[]>([]);
  const header =  document.querySelector('ResponsiveDrawer')
  const headerAdj = header?header.clientHeight:150;
  const controlAdj = 55;
  const [TABLE_BODY_HEIGHT, setTABLE_BODY_HEIGHT] = React.useState<string>(`${window.innerHeight - headerAdj - controlAdj }px`);
  window.addEventListener('resize', ()=>{
    setTABLE_BODY_HEIGHT(`${window.innerHeight - headerAdj }px`);
  })
  const [muiTable, setMuiTable] = React.useState<any>({rpp:25});
  const [clickUrl, setClickUrl] = React.useState(false);
  const [modalStyle] = React.useState(getModalStyle);
  const [vpImageDis, setVpImageDis] = React.useState<any>("");
  const [vsImageDis, setVsImageDis] = React.useState<any>("");

  useEffect(() => {
    if (doneLoading) return;
  GetActiveMaterialData(salesOrg).then((v) => {
    setDoneLoading(true);
        if(v) SetompareMaterData(v);
      })
  }, [doneLoading,salesOrg]);

  const handleModalClose = () => {
        setClickUrl(false);
        //clearCurrent();
  }

  const setCurrent = (editedRow:any) => {
    setVpImageDis(editedRow.vp_image_url);
    setVsImageDis(editedRow.vs_image_url);
    }
    function getBlobNameFromUrl(url:string) {
      const urlObj = new URL(url);
      const pathname = urlObj.pathname; 
      const parts = pathname.split('/');
      return parts.slice(2).join('/'); 
    }
  const deleteImageFromBlob=(image:string)=>{
    const blobName = getBlobNameFromUrl(image);
    deleteVSImageFromBlob(blobName,salesOrg).then((v) => {
       window.location.reload();
      })
      setClickUrl(false);
   } 
 const modalBody = (
      <div style={modalStyle} className={classes.paper} >
      <Grid container spacing={2}  className={classes.modalGrid}>
        <Grid item xs={14} md={14} xl={12}>
          <Typography variant="subtitle1" className={classes.modalText} paragraph>
          </Typography>
          
          <table 
    className="card" 

    style={{ border: "1px solid #dee2e6",width: "100%"}}
    >
    <thead style={{ border: "1px solid #dee2e6"}}>
    <tr>
    <th scope="col" style={{width: "410px;"}} className={classes.imageDispTable}>Vend Smart Image</th>
    <th scope="col" style={{width: "410px;"}}className={classes.imageDispTable}>MDM Image</th>
    </tr>
    </thead>
    <tbody  style={{ border: "1px solid #dee2e6"}}>
        <tr>
            <td style={{width: "410px;",textAlign: "center"}} className={classes.imageDispTable} 
                >
                  <img
                    src={vsImageDis}
                    alt="Vend Smart Image"
                    className={classes.ImagDisp}
                    style={{maxWidth: "60px"}}
                  />
                  <Button
                            color="primary"
                            variant="contained"
                            className={classes.button}
                            onClick={()=>{
                              deleteImageFromBlob(vsImageDis);
                              
                            }}
                            style={{marginLeft: "-45px",marginTop: "70px"}}
                          >
                            Delete
                          </Button>
                </td>
                <td style={{width: "410px;",textAlign: "center"}} className={classes.imageDispTable}>
                  <img
                    src={vpImageDis}
                    alt="MDM Image"
                    className={classes.ImagDisp}
                     style={{maxWidth: "60px"}}
                  />
                </td>
              </tr>
            </tbody>
          </table>
          </Grid>
        </Grid>
      </div>
    );

  return (
    <div className={classes.root}>
      <Typography variant="h4"  align="center" className={classes.paragraph}>
          Compare Material Images
      </Typography>
      <Typography
        variant="subtitle1"
        className={classes.paragraphAct}
        paragraph >
                This section would help us identify the source of the material images,if it is sourced from MDM team or from Vend Smart.
                if image exists in both of them then we can on the URL of the image to compare,and delete the image from Vend Smart(if required).This would only contain the materials which are being 
                actively used.
        </Typography>
        <TableAbstraction
          settingsKey="ADM_EQM"
          loading={!doneLoading}
          options={{
            draggableColumns: {
              enabled: true,
            },
            rowsPerPageOptions: [25, 50, 100],
            serverSide: false,
            selectableRows: "none",
            rowsPerPage: muiTable.rpp,
            onChangeRowsPerPage: (numberOfRows) => {
              muiTable.rpp = numberOfRows;
              setMuiTable(muiTable);
            },
          }}

          columns={[
            {
              label: "Material Name",
              name: "description",
              options: {
                searchable: true,
                filter: false,
              },
            },
            {
              label: "Material Image Name",
              name: "mat_image_name",
              options: {
                searchable: true,
                filter: false,
              },
            },
            {
              label: "Vs_image_repo(VendSmart)",
              name: "vs_image_exist",
            },
            {
              label: "Vp_image_repo(MDM)",
              name: "vp_image_exist",
            }, 
            {
              label: "URL",
              name: "remove",
              options: {
                filter: false,
                setCellProps: () => ({ align: 'right' }),
                renderCell: (params) => {
                if(params.row.vp_image_exist==="YES" && params.row.vs_image_exist==="YES"){
                  return (
                    <Button
                            color="primary"
                            variant="contained"
                            className={classes.button}
                            onClick={()=>{
                              setClickUrl(true);
                              setCurrent(params.row);
                            }}
                          >
                            Click Here
                          </Button>
                  );
                } else{
                  return '';
                }
                   
                },
              },
            },
          ]}
          data={compareMaterData}
        />
        <Modal
                          open={clickUrl}
                          onClose={handleModalClose}
                      >
                          {modalBody}
          
                      </Modal>
    </div>
  );
}
